export default class ViewHelpers {

    static stringifyData(value, separator) {
        if (_.isEmpty(value)) {
            return '';
        }

        if (_.isArray(value)) {
            let resultArray = _.map(value, (item) => {
                if (item.name) {
                    return item.name;
                }
                return item;
            });
            if (separator && typeof separator === 'string') {
                return resultArray.join(separator);
            }
            return resultArray.join(', ');
        }

        return value;
    }

    // Concat elements in list to a markup string.
    // Break row every maxInRow items.
    static formatHtmlList(list, maxInRow, separator) {
        let result = ``;
        let temp = [];
        _.forEach(list, (item) => {
            if (temp.length === maxInRow) {
                result += this.stringifyData(temp, separator) + `<br>`;
                temp = [item];
            } else {
                temp.push(item);
            }
        });
        if (temp.length > 0) {
            result += this.stringifyData(temp, separator) + `<br>`;
        }

        return result;
    }

    static getSanitizedUrlMarkup(link, text) {
        let urlHttpRegex = /^https?:\/\/[a-zA-Z]+(\.)?(:[0-9]+)?.+?(?=\s|$|“|‘|>|<)/;
        if (urlHttpRegex.test(link)) {
            return `<a href="${link}" class="jf-link" target="_blank" >${text}</a>`;
        } else {
            return text;
        }
    }

    static toHtmlRows(text, newLineDelimiter) {
        if (typeof text !== 'string') {
            return;
        }
        if (newLineDelimiter) {
            return text.replace(newLineDelimiter, '<br />');
        }
        return text.replace(/(?:\r\n|\r|\n)/g, '<br />');
    }

    static splitPath(path) {

        let splitedPath = path.split('/');

        if (splitedPath.length === 0) {
            return;
        }

        if (splitedPath[0] !== '') {
            return splitedPath;
        } else {
            return splitedPath.splice(1);
        }
    }

    static getProgress(coverage, percision) {
        let distributedCount = _.isUndefined(coverage.edges_distributed_count) ? coverage.distributed_count : coverage.edges_distributed_count,
            totalCount = _.isUndefined(coverage.total_edges) ? coverage.total_count : coverage.total_edges,
            distributedForPercentage = _.isUndefined(coverage.edges_distributed_count) ? coverage.distributed_bytes : coverage.edges_distributed_count,
            totalForPercentage = _.isUndefined(coverage.total_edges) ? coverage.total_bytes : coverage.total_edges;

        if (0 === distributedCount && 0 === totalCount) return { viewCoverage: '--' };
        let progressInPercents = (0 === distributedForPercentage || 0 === totalForPercentage) ? 0 : (distributedForPercentage / totalForPercentage) * 100;
        return {
            progressInPercents,
            viewCoverage: (progressInPercents.toFixed(percision) * 1)
                + '% (' + distributedCount + ' of ' + totalCount + ')',
        };
    }

    static formatDate(date) {
        return window.Vue.filter("formatDateTime")(date);
    }

    static beautifyAQL(aql) {
        let res = aql;
        try {
            this.getObjectsLocationsInString(aql)
                .forEach(indexSet => {
                    let json = aql.substr(indexSet.start, indexSet.length);
                    let parsed = JSON.stringify(JSON.parse(json), null, '\t');
                    res = res.replace(json, parsed);
                });
            return res;
        } catch (e) {
            return aql;
        }
    }

    static getObjectsLocationsInString(str) {
        let leftCounter = 0, startIndex = null, objectsIndexesInString = [];
        for (let i = 0; i < str.length; i++) {
            if (str[i] === '{') {
                if (leftCounter === 0) startIndex = i;
                leftCounter++;
            } else if (str[i] === '}') {
                leftCounter--;
                if (leftCounter === 0 && startIndex !== null) {
                    objectsIndexesInString.push({ start: startIndex, length: i - startIndex + 1 });
                    startIndex = null;
                }
            }
            leftCounter = (str[i] === '{') ? leftCounter++ : ((str[i] === '}') ? leftCounter-- : leftCounter);
        }
        return objectsIndexesInString;
    }
}



// WEBPACK FOOTER //
// ./modules/distribution/core/utils/view.helpers.js